/**
 * @generated SignedSource<<574b6edb64e1dec0a45edc8e163ef073>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerIncentives_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCoreBuyerIncentives_user">;
  readonly " $fragmentType": "BuyerIncentives_buyer";
};
export type BuyerIncentives_buyer$key = {
  readonly " $data"?: BuyerIncentives_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasTradeStatus"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerIncentives_buyer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "hasTradeStatus"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useCoreBuyerIncentives_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a0c78e6d62451e07f15465b1c32439a4";

export default node;
